module.exports = __webpack_public_path__ + "img/assessment-icon.5784ec9c.svg";